import { DataObjectViewerStore } from './DataObjectViewerStore';
import { BaseComponent } from '../../../../@Framework/Component/BaseComponent';
import { DataObjectBespokeViewerStore } from './DataObjectBespokeViewerStore';

export abstract class DataObjectBespokeViewer<T extends DataObjectBespokeViewerStore = DataObjectBespokeViewerStore> extends BaseComponent<DataObjectViewerStore<T>>
{

}
